import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n/I18nContext";
import { PayoutCard } from "@/components/PayoutCard";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Globe, LogOut, Settings } from "lucide-react";

export default function Parametres() {
  const { user, logout } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();
  const isSeller = user?.role === "seller";

  return (
    <div className="container-page py-8 pb-28 max-w-2xl" data-testid="parametres">
      <Button variant="ghost" onClick={() => navigate("/mon-espace")} className="mb-4 -ml-2 text-muted-foreground hover:text-primary" data-testid="params-back">
        <ArrowLeft className="h-4 w-4 mr-1.5" /> {t("common.back")}
      </Button>

      <div className="flex items-center gap-3 mb-6">
        <span className="h-12 w-12 rounded-2xl bg-primary/10 text-primary flex items-center justify-center"><Settings className="h-6 w-6" /></span>
        <h1 className="font-heading font-extrabold text-2xl text-secondary">{t("space.settings")}</h1>
      </div>

      {isSeller && <div className="mb-6"><PayoutCard /></div>}

      <div className="rounded-2xl bg-card border border-border p-5 mb-6" data-testid="params-language">
        <div className="flex items-center gap-2 mb-3">
          <Globe className="h-5 w-5 text-primary" />
          <h2 className="font-heading font-semibold text-lg text-secondary">{t("space.language")}</h2>
        </div>
        <LanguageSwitcher />
      </div>

      <Button variant="outline" onClick={() => { logout(); navigate("/"); }}
        className="w-full h-14 rounded-2xl border-2 border-destructive text-destructive hover:bg-destructive/5 text-base font-bold" data-testid="params-logout">
        <LogOut className="h-5 w-5 mr-2" /> {t("nav.logout")}
      </Button>
    </div>
  );
}
